/**
 * Agent Types
 *
 * The chat panel's generation controls, shared by AgentService, the tools and the bench.
 * Extracted to avoid circular dependencies.
 */

/**
 * Generation choices the user pinned in the chat panel, the same controls the
 * web Home page offers. Templates are guides; style/set/wrapper are musts.
 * Absent = auto (the model chooses a library guide).
 */
export interface AssistantPins {
    /** Template slug (TEMPLATE_LIBRARY). */
    template?: string;
    /** Style slug (listStyles()). */
    style?: string;
    /** Design-set name (DESIGN_SETS), e.g. "LinearArray". */
    set?: string;
    /** Wrapper id (WRAPPER_LIBRARY), e.g. "exhibition", "display-pinwheel". */
    wrapper?: string;
}

/** Generation types the user allows. All on by default. No video toggle: there is no video tool. */
export interface MediaToggles {
    images: boolean;
    models3d: boolean;
    materials: boolean;
}

export const DEFAULT_MEDIA_TOGGLES: MediaToggles = { images: true, models3d: true, materials: true };

/** The tools each toggle removes from a request when switched off. */
export const MEDIA_TOGGLE_TOOLS: Record<keyof MediaToggles, readonly string[]> = {
    images: ['generate_image'],
    models3d: ['generate_model', 'generate_3d', 'generate_3d_sam3d', 'generate_splat'],
    materials: ['generate_material'],
};

/** Drop the tools a switched-off toggle covers. */
export function filterToolsForMediaToggles<T extends { name: string }>(tools: readonly T[], toggles: MediaToggles): T[] {
    const off = new Set((Object.keys(MEDIA_TOGGLE_TOOLS) as (keyof MediaToggles)[])
        .filter(kind => !toggles[kind])
        .flatMap(kind => MEDIA_TOGGLE_TOOLS[kind]));
    return tools.filter(t => !off.has(t.name));
}
